import { sendWebsocketMessage } from '../../../../../../App';

export function modifySoftOrder({ softOrder, type, value }){
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId: softOrder.tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: softOrder.value.tacticId,
      plugin: softOrder.value.tactic,
      details: {
        [type]: value,
        previousValue: softOrder.value.tacticValue[type],
      }
    },
  };
  sendWebsocketMessage(msg);
}
export function modifySoftOrderWithPreviousValue({ softOrder, previousValue, type, value }){
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId: softOrder.tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: softOrder.value.tacticId,
      plugin: softOrder.value.tactic,
      details: {
        [type]: value,
        previousValue,
      }
    },
  };
  sendWebsocketMessage(msg);
}

export function modifySoftOrderProvideDetails({ softOrder, details }){
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId: softOrder.tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: softOrder.value.tacticId,
      plugin: softOrder.value.tactic,
      details
    },
  };
  sendWebsocketMessage(msg);
}
